class Storage {
  private storageType: 'localStorage' | 'sessionStorage'

  constructor(storageType: 'localStorage' | 'sessionStorage' = 'localStorage') {
    this.storageType = storageType
  }

  get(key: string) {
    const value = window[this.storageType].getItem(key)
    if (!value) return null

    try {
      return JSON.parse(value)
    } catch (e) {
      console.error('parse storage error', e, key, value)
      return null
    }
  }

  set<T>(key: string, value: T) {
    window[this.storageType].setItem(key, JSON.stringify(value))
  }

  remove(key: string) {
    window[this.storageType].removeItem(key)
  }

  clear() {
    window[this.storageType].clear()
  }
}

export const _sessionStorage = new Storage('sessionStorage')

export default new Storage()
